import React from 'react';
import ContactUsBanner from './ContactUsBanner';

const ContactUs = () => (
	<div>
		<ContactUsBanner />
	</div>
);

export default ContactUs;
